export class Constants {
  static techStopLabel = 'Fuel Stop';
}
